export default "__VITE_ASSET__CgSj2uOo__"